import { CoastAlert, CoastAlertKind } from "./CoastAlert.model";
import "./CoastAlertDisplay.style.scss";

interface CoastAlertChildProps {
  isDisplayed: boolean;
  message?: string;
}

export function CoastAlertDisplay({ message, kind }: Pick<CoastAlert, "message" | "kind">) {
  return (
    <div className={`component-coast-alert-display kind-${kind}`}>
      <span>{message}</span>
    </div>
  );
}

export function CoastAlertDisplayError({ isDisplayed, message }: CoastAlertChildProps) {
  return isDisplayed ? (
    <CoastAlertDisplay
      message={message || "There was an error processing your request. Please try again later."}
      kind={CoastAlertKind.ERROR}
    />
  ) : null;
}
